import { useModalContext } from './modalContext';

/**
 * #552 — the content of a 'panel' modal. It takes the height that the pinned
 * header and footer leave, and it scrolls. In a 'form' modal the whole dialog
 * scrolls, so this is a plain block.
 *
 * A form in a panel modal wraps the body and the footer:
 * `<form className="flex flex-col flex-1 min-h-0"><ModalBody>…</ModalBody><ModalFooter saveAsSubmit …/></form>`.
 */
export default function ModalBody({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  const modal = useModalContext();
  const base = modal?.layout === 'panel' ? 'flex-1 min-h-0 overflow-y-auto overscroll-contain p-5' : '';
  return <div className={`${base} ${className}`.trim()}>{children}</div>;
}
